import { Field, FieldProps } from 'formik';

import { FormControl } from '@@/form-components/FormControl';
import { Input } from '@@/form-components/Input';

import { useNotificationChannel } from '../useNotificationChannel';

import { ChannelFieldsProps } from './types';

export function WebhookChannelFields({ index }: ChannelFieldsProps) {
  const channel = useNotificationChannel(index);

  return (
    <div className="space-y-3">
      <Field name={`notificationChannels.${index}.config.name`}>
        {({ field, meta }: FieldProps<string>) => (
          <FormControl
            label="Name"
            size="vertical"
            inputId={`webhook-name-${channel.id}`}
            errors={meta.touched ? meta.error : undefined}
            required
          >
            <Input
              id={`webhook-name-${channel.id}`}
              name={field.name}
              value={field.value || ''}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="Webhook Alerts"
              data-cy={`webhook-name-${channel.id}`}
              className="w-full"
            />
          </FormControl>
        )}
      </Field>
      <Field name={`notificationChannels.${index}.config.url`}>
        {({ field, meta }: FieldProps<string>) => (
          <FormControl
            label="Webhook URL"
            size="vertical"
            inputId={`webhook-url-${channel.id}`}
            errors={meta.touched ? meta.error : undefined}
            required
          >
            <Input
              id={`webhook-url-${channel.id}`}
              name={field.name}
              value={field.value || ''}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="https://example.com/webhook"
              data-cy={`webhook-url-${channel.id}`}
              className="w-full"
            />
          </FormControl>
        )}
      </Field>
    </div>
  );
}
